import { useEffect } from "react";
import { EigenwijsOptions } from "./DoorOptionsProvider.types";
import { applyHeightToEigenwijs, clampDoorHeight } from "./eigenwijsHeight";

interface UseDoorHeightNormalizationParams {
  eigenwijs: EigenwijsOptions | null;
  layoutCode?: string;
  maxDoorHeight: number;
  minDoorHeight: number;
  selectedDoorCode?: string;
  updateEigenwijs: (eigenwijs: EigenwijsOptions) => void;
}

export const useDoorHeightNormalization = ({
  eigenwijs,
  layoutCode,
  maxDoorHeight,
  minDoorHeight,
  selectedDoorCode,
  updateEigenwijs,
}: UseDoorHeightNormalizationParams) => {
  useEffect(() => {
    if (
      !selectedDoorCode ||
      !layoutCode ||
      !eigenwijs?.sizeObjects[0] ||
      minDoorHeight <= 0 ||
      maxDoorHeight <= 0
    ) {
      return;
    }

    const currentHeight = eigenwijs.sizeObjects[0].customHeight;
    const normalizedHeight = clampDoorHeight(
      currentHeight,
      minDoorHeight,
      maxDoorHeight,
    );

    if (normalizedHeight === currentHeight) {
      return;
    }

    updateEigenwijs(
      applyHeightToEigenwijs(eigenwijs, normalizedHeight, layoutCode),
    );
  }, [
    eigenwijs,
    layoutCode,
    maxDoorHeight,
    minDoorHeight,
    selectedDoorCode,
    updateEigenwijs,
  ]);
};
